// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.softlite-color-indicator{
    cursor: pointer;
}
button.softlite-button-reset-color:focus{
    box-shadow: none !important;
    outline: none !important;
}`, "",{"version":3,"sources":["webpack://./assets/js/src/controls/color-select/color-select.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;AACA;IACI,2BAA2B;IAC3B,wBAAwB;AAC5B","sourcesContent":[".softlite-color-indicator{\r\n    cursor: pointer;\r\n}\r\nbutton.softlite-button-reset-color:focus{\r\n    box-shadow: none !important;\r\n    outline: none !important;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
